export default class AsyncMessageDetailsMixin {
    constructor({Model, fetchOnInit}) {
        this.Model = Model;
        this.fetchOnInit = fetchOnInit === undefined ? true : fetchOnInit;
    }

    getMixin() {
        return (function getMixin(options) {
            return {
                props: {
                    entityId: {
                        type: String,
                        required: true,
                    },
                },
                data() {
                    return {
                        model: new options.Model(),
                        isLoading: false,
                        serverError: undefined,
                    };
                },
                created() {
                    if (options.fetchOnInit) {
                        this.fetchData();
                    }
                },
                methods: {
                    // eslint-disable-next-line no-unused-vars
                    async getDelegate(callback) {
                        throw new Error(`Please, implement method getDelegate`);
                    },
                    async fetchData() {
                        this.isLoading = true;
                        this.serverError = false;
                        try {
                            const {fields} = await this.getDelegate(
                                api => api.get({id: this.entityId}),
                            );
                            this.model = new options.Model(fields);
                            this.isLoading = false;
                        } catch (error) {
                            this.serverError = error;
                            this.isLoading = false;
                        }
                    },
                },
            };
        }(this));
    }
}
